import type { LocalStorage } from "@core/data/infrastructures/storage/local-storage";
import { PlatformStorageKeysEnum } from "@core/data/infrastructures/storage/storage.ts";
import type { EnvironmentClient } from "@core/domain/infrastructures/env/environment-client";
import type { Http, HttpFactory } from "@core/domain/infrastructures/http/http";
import { coreTypes } from "@core/root/core-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class IotApiClient {
    public readonly http: Http;

    constructor(
        @inject(coreTypes.infrastructure.EnvironmentClient)
        private readonly env: EnvironmentClient,
        @inject(coreTypes.infrastructure.HttpFactory)
        private readonly httpFactory: HttpFactory,
        @inject(coreTypes.infrastructure.LocalStorage)
        private readonly localStorage: LocalStorage,
    ) {
        this.http = this.httpFactory({
            baseUrl: this.env.apiServerUrl + this.env.apiBaseUrl,
            secure: true,
            defaultRequestConfig: {
                headers: {
                    Accept: "application/json",
                },
            },
        });
    }

    enableAuth(token?: string): void {
        this.http.updateSettings({
            secure: true,
            defaultRequestConfig: {
                headers: {
                    Authorization: `Bearer ${String(token ?? this.localStorage.get(PlatformStorageKeysEnum.AccessToken))}`,
                },
            },
        });
    }

    disableAuth(): void {
        this.http.updateSettings({
            secure: false,
            defaultRequestConfig: {
                headers: {
                    Authorization: "",
                },
            },
        });
    }
}
